import './blog-overview.component.scss'

function parseReading() {
  const trigger = document.querySelector('.blog-overview__grid');
  if (trigger) {
    const articleList = Array.from(document.querySelectorAll('.blog-card'));
    console.log(articleList)
    articleList.forEach(async item => {
      const url = item.firstChild.href;
      const timeReadingWrapper = item.querySelector('.blog-card__date-reading');
      try {
        const response = await fetch(url)
        const rawHtml = await response.text();
        const responseDom = new DOMParser().parseFromString(rawHtml, 'text/html');
        const timeHero = responseDom.querySelector('.hero__time')
        console.log(timeHero)
        if(!timeReadingWrapper.querySelector('.hero__time')){
          timeReadingWrapper.append(timeHero)
        }
      } catch (error) {
        console.error(error);
      }
    })
  }
}
function handleLoadMore() {
  const trigger = document.querySelector('.blog-overview__more button')
  if (trigger) {
    let currentPage = document.querySelector('[data-current-page]').value
    const totalPages = document.querySelector('[data-total-pages]').value
    const nextUrl = document.querySelector('[data-next-url]').value

    if (currentPage >= totalPages) {
      trigger.style.display = 'none'
    }
    trigger.addEventListener('click', async (e) => {
      const wrapper = document.querySelector('.blog-overview__more')
      wrapper.classList.add('blog-overview__more_load')
      e.preventDefault()
      currentPage = Number(currentPage) + 1
      const url = nextUrl.replace(/page=[0-9]+/,'page='+currentPage);
      try {
        const response = await fetch(url)
        const rawHtml = await response.text()
        const products = document.querySelector('.blog-overview__grid')
        const responseDom = new DOMParser().parseFromString(rawHtml, 'text/html')
        const newProducts = responseDom.querySelectorAll('.blog-card')
        products.append(...newProducts)
        parseReading()
        if (currentPage >= totalPages) {
          trigger.style.display = 'none'
        }
      } catch (e) {
        console.warn(e)
      } finally {
        wrapper.classList.remove('blog-overview__more_load')
      }
    })
  }
}
parseReading()
handleLoadMore()
